export default {"src":"/_next/static/media/ftc.634ef820.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};